/**
 * DNC-specific field mapping enums and types for CSV import
 * Based on the Phone model fields and user requirements
 */

/**
 * DNC field mapping enum for mapping CSV columns to DNC/Phone fields
 * @export
 */
export const DncFieldMappingEnum = {
  DoNotImport: 'do_not_import',
  PhoneNumber: 'e164',
  DoNotCall: 'dnc',
  DoNotText: 'dnt',
  DoNotCallScope: 'dnc_scope',
  DoNotCallExpiration: 'dnc_expiration',
  DoNotTextScope: 'dnt_scope',
  DoNotTextExpiration: 'dnt_expiration',
  Consent: 'consent',
  Validity: 'validity',
} as const;

export type DncFieldMappingValue =
  (typeof DncFieldMappingEnum)[keyof typeof DncFieldMappingEnum];

/**
 * Scope values for DNC records
 * @export
 */
export const DncScopeEnum = {
  Company: 'company',
  Powerdialer: 'powerdialer',
  Campaigns: 'campaigns',
} as const;

export type DncScopeValue = (typeof DncScopeEnum)[keyof typeof DncScopeEnum];

/**
 * Boolean value mappings for CSV import
 * Supports various formats: true/false, yes/no, 1/0
 */
export const DncBooleanValueMap = {
  true: true,
  yes: true,
  '1': true,
  y: true,
  on: true,
  enabled: true,

  false: false,
  no: false,
  '0': false,
  n: false,
  off: false,
  disabled: false,

  '': undefined,
  null: undefined,
  undefined: undefined,
} as const;

/**
 * Type for DNC field mapping from CSV columns to DNC fields
 */
export type DncFieldMap = Record<
  string,
  DncFieldMappingValue | undefined | null
>;

/**
 * Type for custom DNC field mapping (for fields not in the standard enum)
 */
export type DncCustomFieldMap = Record<string, string>;
